module.exports = __webpack_public_path__ + "img/pump-4.1b7d696f.png";